import React from 'react';
import classes from './HelpAndFeedback.module.css';
import {Row,Col,Card} from 'react-bootstrap';
import circle from '../../Assets/Images/Successmdpi.png';
import errorImg from '../../Assets/Images/error.jpg'
import {NavLink} from 'react-router-dom';



const MsgBox = props => {
    return(
        <Row className="justify-content-md-center">
                        <Col xs={7} sm={7} md={7}>
                            <Card>
                                <Card.Body>
                                    <div className={classes.thanks}>
                                        <img width="15%" src={circle}/>
                                        <h3 className={classes.greet}>Success</h3>
                                        <br/>
                                        <p className={classes.txt}>
                                        <span style={{fontSize:'18px'}}>Your query/feedback has been submitted successfully.</span>
                                        </p>
                                        <button className={`btn btn-warning ${classes.okBtn}`}>
                                                <span className={classes.okBtnTxt} onClick={()=>props.confirm(props.title)}>OK</span>
                                        </button>   
                                </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
    )
}


export default MsgBox;